import { chakra, defineRecipe } from '@plurall/elo-v3';

const welcomeRecipe = defineRecipe({
  className: 'welcome',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.16',
    paddingBlock: 'space.20',
    paddingInline: 'space.16',
  },
});

const welcomeAvatarRecipe = defineRecipe({
  className: 'welcome__avatar',
  base: {
    position: 'relative',
    flexShrink: 0,
    width: 'size.40',
    height: 'size.40',
    borderRadius: '50%',
    background: 'background.brand.soft',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const welcomeInitialRecipe = defineRecipe({
  className: 'welcome__initial',
  base: {
    fontSize: 'font-size-xlarge',
    fontWeight: 'font-weight-semi-bold',
    color: 'text.primary',
  },
});

const welcomeStatusRecipe = defineRecipe({
  className: 'welcome__status',
  base: {
    position: 'absolute',
    bottom: 'space.2',
    right: 'space.2',
    width: 'size.10',
    height: 'size.10',
    borderRadius: '50%',
    background: 'feedback.success.standard',
    borderWidth: 'size.2',
    borderStyle: 'solid',
    borderColor: 'background.brand.alt',
  },
});

const welcomeBodyRecipe = defineRecipe({
  className: 'welcome__body',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.2',
    minWidth: 0,
  },
});

const welcomeNameRecipe = defineRecipe({
  className: 'welcome__name',
  base: {
    fontSize: 'font-size-medium',
    fontWeight: 'font-weight-semi-bold',
    color: 'foreground.inverse',
  },
});

export const WelcomeFactory = chakra('div', welcomeRecipe);
export const WelcomeAvatarFactory = chakra('div', welcomeAvatarRecipe);
export const WelcomeInitialFactory = chakra('span', welcomeInitialRecipe);
export const WelcomeStatusFactory = chakra('span', welcomeStatusRecipe);
export const WelcomeBodyFactory = chakra('div', welcomeBodyRecipe);
export const WelcomeNameFactory = chakra('span', welcomeNameRecipe);
